import { render } from "./ServList.vue?vue&type=template&id=e068a748"
import script from "./ServList.vue?vue&type=script&lang=js"
export * from "./ServList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__